import type { EndpointDefinition } from "../../../_sdk/types/common";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    cancelSubscription: {
        route: "/workspaces/:workspaceId/billing/subscriptions/cancel",
        method: "POST"
    },
    downgradeSubscription: {
        route: "/workspaces/:workspaceId/billing/subscriptions/downgrade",
        method: "POST"
    },
    reactivateSubscription: {
        route: "/workspaces/:workspaceId/billing/subscriptions/reactivate",
        method: "POST"
    },
    revertPendingDowngrade: {
        route: "/workspaces/:workspaceId/billing/subscriptions/revert-downgrade",
        method: "POST"
    },
    switchSubscriptionBillingInterval: {
        route: "/workspaces/:workspaceId/billing/subscriptions/interval",
        method: "POST"
    },
    endTrialOnSubscription: {
        route: "/workspaces/:workspaceId/billing/subscriptions/end-trial",
        method: "POST"
    },
    updateSubscriptionQuantity: {
        route: "/workspaces/:workspaceId/billing/subscriptions/quantity",
        method: "POST"
    },
    finalizeUpdateSubscriptionQuantity: {
        route: "/workspaces/:workspaceId/billing/subscriptions/quantity-finalize",
        method: "POST"
    }
};
